import {
  createErrorType,
  createFetchType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
  createUpdateType,
} from '../actionHelpers';

// Get Employment Status List
export const GET_EMPLOYMENT_STATUS_LIST_SCOPE =
  'GET_EMPLOYMENT_STATUS_LIST_SCOPE';
export const GET_EMPLOYMENT_STATUS_LIST = createFetchType(
  GET_EMPLOYMENT_STATUS_LIST_SCOPE,
);
export const GET_EMPLOYMENT_STATUS_LIST_SUCCESS = createSuccessType(
  GET_EMPLOYMENT_STATUS_LIST_SCOPE,
);
export const GET_EMPLOYMENT_STATUS_LIST_ERROR = createErrorType(
  GET_EMPLOYMENT_STATUS_LIST_SCOPE,
);
export const GET_EMPLOYMENT_STATUS_LIST_LOADING = createLoadingType(
  GET_EMPLOYMENT_STATUS_LIST_SCOPE,
);

// Get Occupation Categories List
export const GET_OCCUPATION_CATEGORIES_SCOPE =
  'GET_OCCUPATION_CATEGORIES_SCOPE';
export const GET_OCCUPATION_CATEGORIES = createFetchType(
  GET_OCCUPATION_CATEGORIES_SCOPE,
);
export const GET_OCCUPATION_CATEGORIES_SUCCESS = createSuccessType(
  GET_OCCUPATION_CATEGORIES_SCOPE,
);
export const GET_OCCUPATION_CATEGORIES_ERROR = createErrorType(
  GET_OCCUPATION_CATEGORIES_SCOPE,
);
export const GET_OCCUPATION_CATEGORIES_LOADING = createLoadingType(
  GET_OCCUPATION_CATEGORIES_SCOPE,
);

// Get Occupation Category Info
export const GET_OCCUPATION_CATEGORY_INFO_SCOPE =
  'GET_OCCUPATION_CATEGORY_INFO_SCOPE';
export const GET_OCCUPATION_CATEGORY_INFO = createFetchType(
  GET_OCCUPATION_CATEGORY_INFO_SCOPE,
);
export const GET_OCCUPATION_CATEGORY_INFO_SUCCESS = createSuccessType(
  GET_OCCUPATION_CATEGORY_INFO_SCOPE,
);
export const GET_OCCUPATION_CATEGORY_INFO_ERROR = createErrorType(
  GET_OCCUPATION_CATEGORY_INFO_SCOPE,
);
export const GET_OCCUPATION_CATEGORY_INFO_LOADING = createLoadingType(
  GET_OCCUPATION_CATEGORY_INFO_SCOPE,
);

// Get Employment Info
export const GET_EMPLOYMENT_INFO_SCOPE = 'GET_EMPLOYMENT_INFO_SCOPE';
export const GET_EMPLOYMENT_INFO = createFetchType(GET_EMPLOYMENT_INFO_SCOPE);
export const GET_EMPLOYMENT_INFO_SUCCESS = createSuccessType(
  GET_EMPLOYMENT_INFO_SCOPE,
);
export const GET_EMPLOYMENT_INFO_ERROR = createErrorType(
  GET_EMPLOYMENT_INFO_SCOPE,
);
export const GET_EMPLOYMENT_INFO_LOADING = createLoadingType(
  GET_EMPLOYMENT_INFO_SCOPE,
);

// Add Employment Info
export const CREATE_EMPLOYMENT_INFO_SCOPE = 'CREATE_EMPLOYMENT_INFO_SCOPE';
export const CREATE_EMPLOYMENT_INFO = createSubmitType(
  CREATE_EMPLOYMENT_INFO_SCOPE,
);
export const CREATE_EMPLOYMENT_INFO_SUCCESS = createSuccessType(
  CREATE_EMPLOYMENT_INFO_SCOPE,
);
export const CREATE_EMPLOYMENT_INFO_ERROR = createErrorType(
  CREATE_EMPLOYMENT_INFO_SCOPE,
);
export const CREATE_EMPLOYMENT_INFO_LOADING = createLoadingType(
  CREATE_EMPLOYMENT_INFO_SCOPE,
);

// Update Employment Info
export const UPDATE_EMPLOYMENT_INFO_SCOPE = 'UPDATE_EMPLOYMENT_INFO_SCOPE';
export const UPDATE_EMPLOYMENT_INFO = createUpdateType(
  UPDATE_EMPLOYMENT_INFO_SCOPE,
);
export const UPDATE_EMPLOYMENT_INFO_SUCCESS = createSuccessType(
  UPDATE_EMPLOYMENT_INFO_SCOPE,
);
export const UPDATE_EMPLOYMENT_INFO_ERROR = createErrorType(
  UPDATE_EMPLOYMENT_INFO_SCOPE,
);
export const UPDATE_EMPLOYMENT_INFO_LOADING = createLoadingType(
  UPDATE_EMPLOYMENT_INFO_SCOPE,
);

// Get Income Source List
export const GET_INCOME_SOURCE_LIST_SCOPE = 'GET_INCOME_SOURCE_LIST_SCOPE';
export const GET_INCOME_SOURCE_LIST = createFetchType(
  GET_INCOME_SOURCE_LIST_SCOPE,
);
export const GET_INCOME_SOURCE_LIST_SUCCESS = createSuccessType(
  GET_INCOME_SOURCE_LIST_SCOPE,
);
export const GET_INCOME_SOURCE_LIST_ERROR = createErrorType(
  GET_INCOME_SOURCE_LIST_SCOPE,
);
export const GET_INCOME_SOURCE_LIST_LOADING = createLoadingType(
  GET_INCOME_SOURCE_LIST_SCOPE,
);
